var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4628 16.4258L20.3314 9.55713C20.9563 8.93229 20.9563 7.91923 20.3314 7.29439C19.7066 6.66955 18.6935 6.66955 18.0687 7.29439L10.0687 15.2944C9.44384 15.9192 9.44384 16.9323 10.0687 17.5571L18.0687 25.5571C18.6935 26.182 19.7066 26.182 20.3314 25.5571C20.9563 24.9323 20.9563 23.9192 20.3314 23.2944L13.4628 16.4258Z",
    fill: "#171725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow--left.e2568e618b28b2f292b13399ac2b64a2.svg";
export { ForwardRef as ReactComponent };